
<div class="page-header">
  <div class="page-header-content">
    <h1 class="page-title">SSE Name: <span class="dynamic-text">{{ sseName || 'N/A' }}</span></h1>
    <p class="subtitle">Mentor Name: <span class="dynamic-text">{{ mentorName || 'N/A' }}</span></p>
    <p class="days-counter">
      <mat-icon class="calendar-icon">event</mat-icon>
      Day: <span class="dynamic-text">{{ daysSinceCreated }}</span>
    </p>
  </div>
</div>

<!-- Display Loading State -->
@if (loading) {
  <div class="loading-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
}

<!-- Display Error Message -->
@if (error) {
  <div class="error-message">
    <mat-icon color="warn">error</mat-icon>
    <span>{{ error }}</span>
  </div>
}

<div class="container">
  @if (!loading && !error) {
    <form [formGroup]="form" appSubmitDiag="sse" (ngSubmit)="updateChecklist()">
      <div class="form-title">Short Service Employee 30/60/90 Day Checklist</div>
      <table>
        <tr>
          <th class="num1">Mentor’s Initials as Completed</th>
          <th class="num2">SSE Initials as Completed</th>
          <th class="num3">Description</th>
        </tr>
        <!--section 1-->
        <tr>
          <td colspan="3" style="text-align: center; height: 20px; background: linear-gradient(to right, #f7f9fc, #e3e9f0); font-style: italic; font-weight: 500; ">
            Short Service Employee (SSE) sets clear expectations and consequences for safe behaviors.
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill" >
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials1" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials1" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Does not take unnecessary risks.</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials2" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials2" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Asks for help when needed.</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials3" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials3" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Does not try to lift or handle too heavy of a load. Gets mechanical help when needed.</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials4" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials4" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Raises awareness of possible hazards.</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials5" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials5" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Intervenes with unsafe behaviors.</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials6" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials6" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Understands his/her "stop work" authority and responsibility.</td>
        </tr>
        <!--section 2-->
        <tr>
          <td colspan="3" style="text-align: center; height: 20px; background: linear-gradient(to right, #f7f9fc, #e3e9f0); font-style: italic; font-weight: 500;">
            SSE demonstrates ability to do job required:
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials7" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials7" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Works in a craftsman-like manner</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials8" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials8" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Has clear understanding of job to be done</td>
        </tr>
        <!--section 3-->
        <tr>
          <td colspan="3" style="text-align: center; height: 20px; background: linear-gradient(to right, #f7f9fc, #e3e9f0); font-style: italic; font-weight: 500;">
            SSE can use tools safely by:
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials9" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials9" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Communicating</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials10" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials10" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Demonstrating</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials11" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials11" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Observing</td>
        </tr>
        <!--section 4-->
        <tr>
          <td colspan="3" style="text-align: center; height: 20px; background: linear-gradient(to right, #f7f9fc, #e3e9f0); font-style: italic; font-weight: 500;">
            SSE is able to identify the following at the work site:
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials12" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials12" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Struck by hazards</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials13" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials13" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Crushed by hazards</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials14" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials14" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Burns and scalds</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials15" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials15" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Sharp objects and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials16" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials16" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Trip hazards and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials17" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials17" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Electrical hazards and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials18" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials18" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Fall hazards and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials19" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials19" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Hot and/or cold surfaces, piping and equipment</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials20" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials20" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Chemical hazards and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials21" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials21" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Emergency procedures</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials22" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials22" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Emergency communications</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials23" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials23" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Respiratory hazards and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials24" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials24" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Toxic substance hazards and precautions</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials25" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials25" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Any additional hazards specific to the job site</td>
        </tr>
        <!--section 5-->
        <tr>
          <td colspan="3" style="text-align: center; height: 20px; background: linear-gradient(to right, #f7f9fc, #e3e9f0); font-style: italic; font-weight: 500;">
            Short Service Employee exhibits compliance to:
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials26" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials26" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>General safety rules and policies</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials27" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials27" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Safety rules and policies specific to the job being performed</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials28" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials28" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>Housekeeping policies</td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>Mentor’s Initials</mat-label>
              <input matInput formControlName="mentorInitials29" placeholder="Mentor’s Initials">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill">
              <mat-label>SSE Initials</mat-label>
              <input matInput formControlName="sseInitials29" placeholder="SSE Initials">
            </mat-form-field>
          </td>
          <td>PPE requirements</td>
        </tr>
      </table>
      <div class="button-container">
        <button mat-raised-button color="primary" class="submit-button" [disabled]="isSubmitting">{{ isSubmitting ? 'Submitting…' : 'Update' }}</button>
      </div>

      @if (warningMessage) {
        <div class="error-message">{{ warningMessage }}</div>
      }
    </form>
  }
</div>
